export const CategoriesBreakPoints = {
  320: {
    slidesPerView: 2.65,
    spaceBetween: 10,
  },
  991: { slidesPerView: 4, spaceBetween: 15 },
  1280: {
    slidesPerView: 6,
    spaceBetween: 24,
  },
};

export const BrandsBreakPoints = {
  320: {
    slidesPerView: 3.25,
    spaceBetween: 16,
  },
  991: { slidesPerView: 4, spaceBetween: 25 },
  1280: {
    slidesPerView: 6,
    spaceBetween: 50,
  },
};

export const TestimonialsBreakPoints = {
  320: {
    slidesPerView: 1.25,
    spaceBetween: 10,
  },
  750: { slidesPerView: 'auto', spaceBetween: 20 },
  // 1280: {
  //   slidesPerView: 2.15,
  //   spaceBetween: 30,
  // },
};

export const GridProductsBreakpoints = {
  320: {
    slidesPerView: 1.25,
    grid: {
      fill: 'row',
      rows: 1,
    },
    spaceBetween: 13,
  },
  991: {
    slidesPerView: 2,
    grid: {
      fill: 'row',
      rows: 2,
    },
    spaceBetween: 15,
  },
  1280: {
    slidesPerView: 3,
    grid: {
      fill: 'row',
      rows: 2,
    },
    spaceBetween: 32,
  },
};

export const ProductListBreakpoints = {
  320: { spaceBetween: 9, slidesPerView: 2.25 },
  991: { spaceBetween: 15, slidesPerView: 3 },
  1280: { spaceBetween: 31, slidesPerView: 5 },
};
export const ProductListBreakpointsForCart = {
  320: { spaceBetween: 9, slidesPerView: 1 },
  991: { spaceBetween: 15, slidesPerView: 2 },
};
